const level: any = {};

export function CEFRlevelmap(course: number) {
  switch (course) {
    case 0:
      level.cefr = "A1";
      level.cefrHalfLevel = "A1.1";
      level.courseLevel = "A1.1";
      break;
    case 1:
      level.cefr = "A1";
      level.cefrHalfLevel = "A1.2";
      level.courseLevel = "A1.2";
      break;
    case 2:
      level.cefr = "A2";
      level.cefrHalfLevel = "A2.1";
      level.courseLevel = "A2.1";
      break;
    case 3:
      level.cefr = "A2";
      level.cefrHalfLevel = "A2.1";
      level.courseLevel = "A2.2";
      break;
    case 4:
      level.cefr = "A2";
      level.cefrHalfLevel = "A2.2";
      level.courseLevel = "B1.1";
      break;
    case 5:
      level.cefr = "B1";
      level.courseLevel = "B1.1";
      level.cefrHalfLevel = "B1.1";
      break;
    case 6:
      level.cefr = "B1";
      level.cefrHalfLevel = "B1.1";
      level.courseLevel = "B1.2";
      break;
    case 7:
      level.cefr = "B1";
      level.cefrHalfLevel = "B1.2";
      level.courseLevel = "B2.1";
      break;
    case 8:
      level.cefr = "B2";
      level.cefrHalfLevel = "B2.1";
      level.courseLevel = "B2.2";
      break;
    case 9:
      level.cefr = "B2";
      level.cefrHalfLevel = "B2.2";
      level.courseLevel = "C1.1";
      break;
    case 10:
      level.cefr = "C1";
      level.cefrHalfLevel = "C1.1";
      level.courseLevel = "C1.2";
      break;
    default:
      level.cefr = "NIL";
      level.cefrHalfLevel = "NIL";
      level.courseLevel = "NIL";
      break;
  }
  return level;
}

let NextLevel: any = "";
export function CEFRNextLevelmap(courseLevel: string) {
  switch (courseLevel) {
    case "A1.1":
      NextLevel = "A1.2";
      break;
    case "A1.2":
      NextLevel = "A2.1";
      break;
    case "A2.1":
      NextLevel = "A2.2";
      break;
    case "A2.2":
      NextLevel = "B1.1";
      break;
    case "B1.1":
      NextLevel = "B1.2";
      break;
    case "B1.2":
      NextLevel = "B2.1";
      break;
    case "B2.1":
      NextLevel = "B2.2";
      break;
    case "B2.2":
      NextLevel = "NIL";
      break;
    case "C1.1":
      NextLevel = "NIL";
      break;
    default:
      NextLevel = "NIL";
      break;
  }
  return NextLevel;
}

export const getUserNextAssessmentLevel = (courseLevel: string) => {
  switch (courseLevel) {
    case "A1.1":
      return "A1.2";
    case "A1.2":
      return "A2.1";
    case "A2.1":
      return "A2.2";
    case "A2.2":
      return "B1.1";
    case "B1.1":
      return "B1.2";
    case "B1.2":
      return "B2.1";
    case "B2.1":
      return "B2.2";
    case "B2.2":
      return "C1.1";
    case "C1.1":
      return "C1.2";
    case "C1.2":
      return "C2.1";
    case "C2.1":
      return "C2.2";
    case "C2.2":
      return "NIL";
    default:
      return "NIL";
  }
};

// tslint:disable-next-line: cognitive-complexity
export function GetLevel(
  score: number,
  bSpeakingSectionMissing: false,
  isStepPlusUser: boolean
) {
  if (isStepPlusUser) {
    if (bSpeakingSectionMissing) {
      if (score <= 90) return 0;
      else if (score <= 180) return 1;
      else if (score <= 260) return 2;
      else if (score <= 354) return 3;
      else if (score <= 465) return 4;
      else if (score <= 576) return 5;
      else if (score <= 687) return 6;
      else if (score <= 798) return 7;
      else if (score <= 909) return 8;
      else if (score <= 1049) return 9;
      else if (score <= 1190 || score >= 1190) return 10;
    } else {
      if (score <= 120) return 0;
      else if (score <= 240) return 1;
      else if (score <= 347) return 2;
      else if (score <= 472) return 3;
      else if (score <= 620) return 4;
      else if (score <= 768) return 5;
      else if (score <= 916) return 6;
      else if (score <= 1064) return 7;
      else if (score <= 1212) return 8;
      else if (score <= 1399) return 9;
      else if (score <= 1586 || score >= 1586) return 10;
    }
  } else {
    if (score <= 60) return 0;
    else if (score <= 120) return 1;
    else if (score <= 173) return 2;
    else if (score <= 236) return 3;
    else if (score <= 310) return 4;
    else if (score <= 384) return 5;
    else if (score <= 458) return 6;
    else if (score <= 532) return 7;
    else if (score <= 606) return 8;
    else if (score <= 699) return 9;
    else if (score <= 793 || score >= 793) return 10;
  }
  return 0;
}

export function getLevelUserLevel(courseLevel: string) {
  switch (courseLevel) {
    case "A1.1":
      return "Elementary";
    case "A1.2":
      return "Elementary";
    case "A2.1":
      return "Pre-Intermediate";
    case "A2.2":
      return "Pre-Intermediate";
    case "B1.1":
      return "Intermediate";
    case "B1.2":
      return "Intermediate";
    case "B2.1":
      return "Upper-Intermediate";
    case "B2.2":
      return "Upper-Intermediate";
    case "C1.1":
      return "Advanced";
  }
}

export function getSkillsUserLevel(courseLevel: string) {
  switch (courseLevel) {
    case "A1.1":
      return "Beginner";
    case "A1.2":
      return "Beginner";
    case "A2.1":
      return "Lower Intermediate";
    case "A2.2":
      return "Lower Intermediate";
    case "B1.1":
      return "Higher Intermediate";
    case "B1.2":
      return "Higher Intermediate";
    case "B2.1":
      return "Advanced";
    case "B2.2":
      return "Advanced";
    case "C1.1":
      return "Advanced";
    default:
      return "";
  }
}

export const tempSoloCourseLevel = (userLevel: string) => {
  switch (userLevel) {
    case "A1.1":
      return "A1.1";
    case "A1.2":
      return "A1.1";
    case "A2.1":
      return "A2.1";
    case "A2.2":
      return "A2.1";
    case "B1.1":
      return "B1.1";
    case "B1.2":
      return "B1.1";
    case "B2.1":
      return "B2.2";
    case "B2.2":
      return "B2.2";
    case "C1.1":
      return "B2.2";
    default:
      return "";
  }
};

export const getSoloCourseLevel = (userLevel: string) => {
  switch (userLevel) {
    case "A1.1":
      return "A1.2";
    case "A1.2":
      return "A2.1";
    case "A2.1":
      return "A2.2";
    case "A2.2":
      return "B1.1";
    case "B1.1":
      return "B1.2";
    case "B1.2":
      return "B2.1";
    case "B2.1":
      return "B2.2";
    case "B2.2":
      return "B2.2";
    case "C1.1":
      return "B2.2";
    default:
      return "";
  }
};
